import useAnalytics from "hooks/useAnalytics";

import { ANALYTICS } from "./constants";

const useModulesAnalytics = () => {
  return useAnalytics({
    page: ANALYTICS.analyticsPage,
  });
};

export default useModulesAnalytics;
